import { PropsWithChildren, ReactNode } from 'react';
import { styled } from 'styled-components';

export interface WhiteBlockProps extends PropsWithChildren {
	title?: string;
	className?: string;
	dataQaId?: string;
	// Optional action rendered inline with the title, aligned to the right
	headerAction?: ReactNode;
}

const StyledWhiteBlock = styled.div`
	padding: 16px;
	display: flex;
	flex-direction: column;
	border-radius: 16px;
	background: #fff;
	box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.12);
	gap: 16px;
	width: 100%;

	@media screen and (min-width: 768px) {
		border-radius: 24px;
		padding: 32px;
	}
`;

const StyledHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

const StyledTitle = styled.div`
	color: #0f0f41;
	font-size: 18px;
	font-weight: 800;
	line-height: 28px;
	margin-right: 24px;

	@media screen and (min-width: 768px) {
		font-size: 24px;
		line-height: 32px;
	}
`;

function WhiteBlockHeader({ title, headerAction }: { title?: string; headerAction?: ReactNode }) {
	if (!title && !headerAction) {
		return null;
	}

	return (
		<StyledHeader>
			{title && <StyledTitle>{title}</StyledTitle>}
			{headerAction}
		</StyledHeader>
	);
}

export function WhiteBlock({
	title,
	children,
	className,
	dataQaId,
	headerAction,
}: WhiteBlockProps) {
	return (
		<StyledWhiteBlock className={className} data-qa-id={dataQaId}>
			<WhiteBlockHeader title={title} headerAction={headerAction} />
			{children}
		</StyledWhiteBlock>
	);
}

export default WhiteBlock;
